import { graphql, useStaticQuery } from "gatsby";

export default () => useStaticQuery(graphql`{
    data: markdownRemark ( frontmatter: { identifier: { eq: "portfolioPage" } } ) {
        frontmatter {
            portfolioItems
            seoSubtitle
            seoDescription
            seoKeywords
            backgroundImage {
                childImageSharp {
                    fluid(maxWidth: 1920) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    }
}`);
